module.exports = __webpack_public_path__ + "static/media/membership2026-child-card.6b690838.png";